/**
 * @description Role of IImportable
 * @see {@link IImportable}
 */
export enum ImportRole {
	AD_SDK = 'ImportRole.AD_SDK',
	EXECUTABLE = 'ImportRole.EXECUTABLE',
	LOW_LEVEL_PLAYER = 'ImportRole.LOW_LEVEL_PLAYER',
	PLAYER = 'ImportRole.PLAYER',
	PLAYER_UI = 'ImportRole.PLAYER_UI',
	SMART_TAG_SKIN = 'ImportRole.SMART_TAG_SKIN',
}